import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { operations } from '@luxuryescapes/contract-svc-promo/generated';

import { getChannelMarkupListV2 } from '~/services/PromoService';

import { channelMarkupV2QueryKeys } from './useGetChannelMarkupV2ById';

type Params = {
  query: operations['getChannelMarkupListV2']['parameters']['query'];
  enabled?: boolean;
};

export function useGetChannelMarkupV2List({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: [...channelMarkupV2QueryKeys.all, 'list', query] as const,
    queryFn: async ({ signal }) => (await getChannelMarkupListV2(query, { signal })).result,
    enabled,
    placeholderData: keepPreviousData,
  });
}
